import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import { Banner, palette } from '@workspace/frontend-kit'
import { REQUESTER_CALLOUT } from './utils/_utils'

const RequesterCallout = () => (
    <Banner
        title={REQUESTER_CALLOUT.title}
        text={REQUESTER_CALLOUT.text}
        icon={<InfoRoundedIcon />}
        slotOverrides={{
            title: {
                color: palette.typography[900],
                fontWeight: 600,
            },
        }}
    />
)

export default RequesterCallout
